@if (type() === 'select') {
  <rt-bulk-select
    [allSelected]="displaySelected()"
    [selectedCount]="displayCount()"
    [disabled]="disabled()"
    [active]="active()"
    [indeterminateState]="displayIndeterminate()"
    (select)="handleSelect($event)"
    [variant]="variant()"
  />
}

@if (type() === 'checkbox') {
  <rt-checkbox
    [indeterminateState]="displayIndeterminate()"
    [checked]="displaySelected()"
    [disabled]="disabled()"
    (valueChange)="handleSelect($any($event))"
    (click)="$event.stopPropagation()"
  >
    <ng-content />
  </rt-checkbox>
}
